import {
  DealEnum as GQLDealEnum,
  SettlementDeal as GQLSettlementDeal,
} from '../../generated/graphql';

export const DealEnum = Object.freeze({
  ArtistGuarantee: GQLDealEnum.ArtistGuarantee,
  ArtistGuaranteePlusGborAfterExpenses: GQLDealEnum.ArtistGuaranteePlusGborAfterExpenses,
  ArtistGuaranteeVsGbor: GQLDealEnum.ArtistGuaranteeVsGbor,
  ArtistGuaranteeVsGborAfterExpenses: GQLDealEnum.ArtistGuaranteeVsGborAfterExpenses,
  FlatFee: GQLDealEnum.FlatFee,
  Gbor: GQLDealEnum.Gbor,
  GborAfterExpenses: GQLDealEnum.GborAfterExpenses,
  GuaranteeToVenue: GQLDealEnum.GuaranteeToVenue,
  None: GQLDealEnum.None,
  PercentAfterHit: GQLDealEnum.PercentAfterHit,
  PercentWithHit: GQLDealEnum.PercentWithHit,
  Rental: GQLDealEnum.Rental,
  SalesPercentage: GQLDealEnum.SalesPercentage,
});

export type DealEnum = (typeof DealEnum)[keyof typeof DealEnum];

export type SettlementDeal = {
  id?: number;
  dealType?: DealEnum;
  amount?: number;
  percent?: number;
  expenseAmount?: number;
  firstAmount?: number;
  hitAmount?: number;
  showTicketSales?: boolean;
};

export type DealAttributes = {
  id?: number;
  dealType?: DealEnum;
  amount?: number;
  percent?: number;
  expenseAmount?: number;
  firstAmount?: number;
  hitAmount?: number;
  showTicketSales?: boolean;
  _destroy?: boolean;
};

export const fromGql = (item: GQLSettlementDeal): SettlementDeal => ({
  id: item.id,
  dealType: item.dealType as DealEnum | undefined,
  amount: item.amount ?? undefined,
  percent: item.percent ?? undefined,
  expenseAmount: item.expenseAmount ?? undefined,
  firstAmount: item.firstAmount ?? undefined,
  hitAmount: item.hitAmount ?? undefined,
  showTicketSales: item.showTicketSales ?? undefined,
});
